/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { GetColourArray } from "../../components/Common";
import * as Paper from "../layout/PaperFunctions";
//import { WipeSkylights3D } from "../layout/Babylon3D";

import * as BSL_Common from "../../components/BSL_CommonControls";
import BSL_Select from "../../components/BSL_Select";
import BSL_ColourSelector from "../../components/BSL_ColourSelector";
import BSL_TextInput from "../../components/BSL_TextInput";
import * as APP from "../../redux_store/appState";
import * as CONFIG from "../../redux_store/configState";
import {
    updateAreaSpecification,
    updateAreaSpecificationRoofSheet,
    updateAreaSpecificationShape,
} from "../../redux_store/jobState";
import { BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";

import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";
import BSL_Button from "../../components/BSL_Button";
import SpecSetRoofLayingOffset from "../context_options/SpecSetRoofLayingOffset";

const useStyles = makeStyles({
    root: {
        padding: "0px 8px 8px 8px",
    },
    cutoutSummary: {
        color: "white",
        fontSize: "70%",
    },
    paper_root: {
        background: "#090909ad",
    },
});

// Get Index of item using description matching
const getProductItemFromIndex = (index, pricefile) => {
    if (!pricefile || !pricefile?.data) return index;
    let obj = pricefile.data.find((o) => o.ProductIndex === index);

    if (obj) return obj;
    else return null;
};

const getSpanText = ({ RoofSheetParameters, span }) => {
    let maxEndSpan = RoofSheetParameters?.MaxEndSheetSpan;
    if (!span) return "??mm";
    const color = span === maxEndSpan ? "#7373f7" : "";

    return (
        <p
            style={{
                margin: 0,
                color: color,
            }}
        >
            {span}mm
        </p>
    );
};

const getRooftypeLower = ({ RoofSheetParameters }) => {
    if (RoofSheetParameters?.RoofGroupType) {
        if (
            RoofSheetParameters?.RoofGroupType &&
            RoofSheetParameters?.RoofGroupType?.toLowerCase &&
            RoofSheetParameters?.RoofGroupType.toLowerCase
        )
            return RoofSheetParameters?.RoofGroupType.toLowerCase();
    }
};

const getDownlightMenu = ({ downlight_options, RoofType_lower, pricefile }) => {
    let downlight_menu_items = [];
    if (downlight_options && RoofType_lower && RoofType_lower !== "") {
        for (var downlight of downlight_options) {
            let detail = getProductItemFromIndex(downlight, pricefile);
            if (detail?.ProductDescription?.toLowerCase) {
                const productDescriptionLower = detail.ProductDescription.toLowerCase();

                const roofTypes = [
                    { type: "bondor", condition: RoofType_lower.includes("bondor") },
                    { type: "versiclad", condition: RoofType_lower.includes("versiclad") },
                    { type: "apollo", condition: RoofType_lower.includes("apollo") },
                ];

                roofTypes.forEach(({ type, condition }) => {
                    if (condition && productDescriptionLower.includes(type)) {
                        downlight_menu_items.push({
                            Key: downlight,
                            Display: detail.ProductDescription,
                            Colours: detail.Colours.split(","),
                        });
                    }
                });
            }
        }
    }

    if (downlight_menu_items.length > 0) downlight_menu_items.push({ Key: "None", Display: "No Downlights" });
    return downlight_menu_items;
};

const getFanBracketMenu = ({ fan_options, RoofType_lower, pricefile }) => {
    let fan_menu_items = [];
    const roofsheets_with_fans = ["bondor", "versiclad", "apollo"];
    if (fan_options && RoofType_lower && RoofType_lower !== "") {
        for (var fanBracket of fan_options) {
            let detail = getProductItemFromIndex(fanBracket, pricefile);
            if (detail && detail?.ProductDescription && detail?.ProductDescription.toLowerCase) {
                roofsheets_with_fans.forEach((keyword) => {
                    // Check if the keyword is present in the RoofType_lower string
                    if (RoofType_lower.includes(keyword)) {
                        // Check if the ProductDescription includes the keyword (case-insensitive)
                        if (detail?.ProductDescription.toLowerCase().includes(keyword)) {
                            // Add item to the fan_menu_items array
                            fan_menu_items.push({
                                Key: fanBracket,
                                Display: detail?.ProductDescription,
                                Colours: detail?.Colours.split(","),
                            });
                        }
                    }
                });
            }
        }
    }
    if (fan_menu_items.length > 0) fan_menu_items.push({ Key: "None", Display: "No Fan Brackets." });
    return fan_menu_items;
};

const getSheetMenu = ({ roofsheet_groups, is_cyclonic, config }) => {
    let sheet_menu_items = [];
    if (roofsheet_groups) {
        for (let key of roofsheet_groups) {
            var sheet = config.roofsheet_types[key];

            let disabled = false;
            let disabledTooltip = null;
            if (is_cyclonic && !sheet?.allow_cyclonic) {
                disabled = true;
                disabledTooltip = "Not available in Cyclonic";
            }

            if (sheet) {
                let name = key;
                if (sheet?.[CONFIG.ROOFSHEET_TYPE.NAME]) name = sheet[CONFIG.ROOFSHEET_TYPE.NAME];
                sheet_menu_items.push({
                    Key: key,
                    Display: name,
                    Thumbnail: sheet[CONFIG.ROOFSHEET_TYPE.THUMBNAIL],
                    disabled: disabled,
                    disabledTooltip: disabledTooltip,
                });
            }
        }
    }
    return sheet_menu_items;
};

const getSheetMenuSub = ({ roofsheetgroup, is_cyclonic, RoofSheetParameters }) => {
    let sheet_menu_sub_items = [];
    if (roofsheetgroup?.[CONFIG.ROOFSHEET_TYPE.SUBTYPES]) {
        for (let key in roofsheetgroup?.[CONFIG.ROOFSHEET_TYPE.SUBTYPES]) {
            let item = roofsheetgroup?.[CONFIG.ROOFSHEET_TYPE.SUBTYPES][key];

            let disabled = false;
            let disabledTooltip = null;
            if (is_cyclonic && !item?.allow_cyclonic) {
                disabled = true;
                disabledTooltip = "Not available in Cyclonic";
            }
            if (item.discontinued) disabled = true;

            if (!item?.discontinued || key === RoofSheetParameters.RoofSubType)
                sheet_menu_sub_items.push({
                    Key: key,
                    Display: (item?.name ? item?.name : key) + (item?.discontinued ? " (Discontinued)" : ""),
                    Thumbnail: item?.[CONFIG.ROOFSHEET_TYPE.THUMBNAIL] ? item?.[CONFIG.ROOFSHEET_TYPE.THUMBNAIL] : null,
                    disabled: disabled,
                    disabledTooltip: disabledTooltip,
                });
        }
    }
    return sheet_menu_sub_items;
};

const getSpanItems = ({ roofsheetgroup_subtype, is_cyclonic, area_design_specs }) => {
    let span_items = [];

    if (roofsheetgroup_subtype) {
        if (!is_cyclonic) {
            if (roofsheetgroup_subtype?.allow_nofoot_traffic !== false) {
                if (
                    !(
                        area_design_specs &&
                        area_design_specs.SKYLIGHTS &&
                        area_design_specs.SKYLIGHTS.length > 0 &&
                        (roofsheetgroup_subtype.roofsheet_id.includes("Corrugated") ||
                            roofsheetgroup_subtype.roofsheet_id.includes("TL5")) &&
                        window.FIELDERS
                    )
                ) {
                    span_items.push({
                        Key: "No Foot Traffic",
                        Display: "No Foot Traffic",
                    });
                }
            }
            if (roofsheetgroup_subtype && roofsheetgroup_subtype.allow_non_trafficable)
                span_items.push({
                    Key: "Non-Trafficable",
                    Display: "Non-Trafficable",
                });
        } else {
            if (roofsheetgroup_subtype?.allow_nofoot_traffic !== false) {
                if (
                    !(
                        area_design_specs &&
                        area_design_specs.SKYLIGHTS &&
                        area_design_specs.SKYLIGHTS.length > 0 &&
                        (roofsheetgroup_subtype.roofsheet_id.includes("Corrugated") ||
                            roofsheetgroup_subtype.roofsheet_id.includes("TL5")) &&
                        window.FIELDERS
                    )
                ) {
                    span_items.push({
                        Key: "No Foot Traffic - Cyclonic",
                        Display: "No Foot Traffic - Cyclonic",
                    });
                }
            }
            if (roofsheetgroup_subtype && roofsheetgroup_subtype.allow_non_trafficable)
                span_items.push({
                    Key: "Non-Trafficable - Cyclonic",
                    Display: "Non-Trafficable - Cyclonic",
                });
        }
    }
    return span_items;
};

const handleUpdateRoofData =
    (props) =>
    (dataField) =>
    (event, value = null) => {
        const { job, areaIndex, dispatch, APP } = props;

        if (value === null) value = event?.target?.value ?? event;
        if (value?.props?.value) value = value.props.value;

        let error = dispatch(updateAreaSpecificationRoofSheet(areaIndex, null, dataField, value));
        if (error?.error) {
            dispatch(APP.showDialogData(error));
        }

        // Wipe skylights & overhangs if changing only the roofsheet type
        if (dataField === "RoofGroupType") {
            const areaSpecs = job["AreaSpecifications"][areaIndex];
            const currentShape = areaSpecs["SHAPE"];

            let messages = [];

            // Clear overhangs if they exist
            if (currentShape.OH_Back_Sheet > 0 || currentShape.OH_Front_Sheet > 0) {
                ["OH_Front_Sheet", "OH_Back_Sheet"].forEach((sheet) =>
                    dispatch(updateAreaSpecification(Number(areaIndex), "SHAPE", sheet, 0))
                );
                messages.push("Overhangs have been wiped as roofsheets have different sizes/rules.");
            }

            // Remove skylights
            dispatch(updateAreaSpecification(Number(areaIndex), "SKYLIGHTS", null, []));

            if (Paper.GetSkylights().length > 0) {
                messages.push("Skylights have been wiped as sheets have different sizes/rules.");
            }

            // Show a single merged message if needed
            if (messages.length > 0) {
                dispatch({
                    type: APP.SHOW_DESIGNER_MESSAGE,
                    message: {
                        message: messages.join(" "),
                        type: "info",
                    },
                });
            }
        }
    };

const handleWipeSkylights =
    (props) =>
    (areaIndex = -1) =>
    (event) => {
        const { dispatch, app } = props;
        Paper.WipeSkylights(areaIndex);
        const threedMode = app.designer[APP.THREED_MODE];
        //if (threedMode) WipeSkylights3D(areaIndex);
        dispatch(updateAreaSpecification(Number(areaIndex), "SKYLIGHTS", null, []));
    };

export default function SpecRoofSheetTools(props) {
    const { areaIndex } = props;

    const classes = useStyles();
    const dispatch = useDispatch();
    const app = useSelector((state) => state.app);
    const job = useSelector((state) => state.job);
    const user = useSelector((state) => state.app?.user);
    const config = useSelector((state) => state.config);
    const pricefile = useSelector((state) => state.app?.pricefile);

    const area_design_specs = job?.AreaSpecifications?.[areaIndex];
    const carportMode = job?.DesignParameters?.CarportMode === 1;
    const designType = carportMode ? "National Carport" : area_design_specs.SHAPE.DesignType;
    const design_option = config?.design_options?.[designType];
    const roofsheet_groups = config.design_options[designType]?.roofsheet_groups;
    const RoofSheetParameters = area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING];
    const downlight_options = config.design_options[designType]?.downlight_options;
    const RoofType_lower = getRooftypeLower({ RoofSheetParameters });
    const downlight_menu_items = getDownlightMenu({ downlight_options, RoofType_lower, pricefile });
    const defaultRoofGroupType = config.design_options[designType]?.roofsheet_default?.grouptype;
    const defaultRoofSubType = config.design_options[designType]?.roofsheet_default?.subtype;
    const roofsheetgroup =
        config.roofsheet_types?.[RoofSheetParameters.RoofGroupType] ?? config.roofsheet_types?.[defaultRoofGroupType];
    const roofsheetgroup_subtype =
        roofsheetgroup?.[CONFIG.ROOFSHEET_TYPE.SUBTYPES]?.[RoofSheetParameters.RoofSubType] ??
        roofsheetgroup?.[CONFIG.ROOFSHEET_TYPE.SUBTYPES]?.[defaultRoofSubType];
    const fan_bracket = roofsheetgroup.fan_bracket;

    //for overhangs

    const ShapeParameters = area_design_specs?.SHAPE;
    let maxFrontBackEndSpan =
        area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_frontback_end_span;
    let min_front_overhang = area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.min_front_overhang;
    let min_side_overhang = area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.min_side_overhang;
    let max_side_overhang = area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_side_overhang;
    const updateShapeDataValue = (dataField, value = null) => {
        let error = dispatch(updateAreaSpecificationShape(areaIndex, null, dataField, value));
        if (error && error.error) {
            dispatch(APP.showDialogData(error));
        }
    };
    const updateShapeData =
        (dataField) =>
        (event, value = null) => {
            if (value === null) value = event?.target?.value ? event?.target?.value : event;

            return updateShapeDataValue(dataField, value);
        };

    let is_cyclonic = false;
    const region = job?.SiteParameters?.WindData?.WindZoneAS1170?.region;
    if (region === "C" || region === "D") {
        is_cyclonic = true;
    }

    const skylight_list = roofsheetgroup_subtype?.skylights || roofsheetgroup?.skylights;
    const skylight_sheet = skylight_list?.[RoofSheetParameters.SkylightSubType] || {};
    const skylightColourList = skylight_sheet?.[CONFIG.ROOFSHEET_TYPE.COLOURS] || "Clear";
    const skylightsflag = skylight_sheet;

    const colourMatch = {
        "Match Roofsheet": RoofSheetParameters.RoofSheetColour,
        "Match Barge": RoofSheetParameters.FlashingColour,
    };

    const ridgeColourMatch = {
        "Match Roofsheet": RoofSheetParameters.RoofSheetColour.split("/")[0],
        "Match Barge": RoofSheetParameters.FlashingColour.split("/")[0],
    };

    const valid_barge_colours = design_option?.flashing_colours
        ? [design_option.flashing_colours]
        : config.colour_arrays["Colorbond Single & Double Sided"];
    const valid_ridge_colours = design_option.ridge_colours
        ? [design_option.ridge_colours]
        : config.colour_arrays["Colorbond Single & Double Sided"];

    let colourList = roofsheetgroup_subtype?.[CONFIG.ROOFSHEET_TYPE.COLOURS];

    if (typeof colourList === "object") {
        let region = job?.Distributor?.Offer?.Regions?.[0] || job?.App?.temp_POA;
        let colours_list_to_use = colourList[region] || colourList["DEFAULT"];
        colourList = colours_list_to_use || colourList;
    }

    const roofSheetColourArray = GetColourArray(colourList, config.colour_arrays);

    const downlight_colour_menu_item =
        downlight_menu_items.find((e) => e.Key === RoofSheetParameters?.DownlightData?.DownlightSelection)?.Colours ||
        [];

    const wipeSkylights = handleWipeSkylights({ dispatch, app });
    const updateRoofData = handleUpdateRoofData({ job, areaIndex, dispatch, APP });
    const span_items = getSpanItems({ roofsheetgroup_subtype, is_cyclonic, area_design_specs });
    const sheet_menu_items = getSheetMenu({ roofsheet_groups, is_cyclonic, config });
    const generateSpanText = (spanText) => getSpanText({ span: spanText, RoofSheetParameters });
    const sheet_menu_sub_items = getSheetMenuSub({ roofsheetgroup, is_cyclonic, RoofSheetParameters });

    if (
        (RoofSheetParameters.RoofSpan == null ||
            span_items.filter((e) => e.Key === RoofSheetParameters.RoofSpan).length === 0) &&
        span_items.length > 0
    ) {
        updateRoofData("RoofSpan")(span_items[0].Key);
    }

    let max_right_overhang = Math.min(
        ShapeParameters.Length / 4,
        design_option?.overhang_right_range?.max ? design_option?.overhang_right_range?.max : 2100,
        max_side_overhang !== undefined ? max_side_overhang : 99999
    );

    let max_left_overhang = Math.min(
        ShapeParameters.Length / 4,
        design_option?.overhang_left_range?.max ? design_option?.overhang_left_range?.max : 2100,
        max_side_overhang !== undefined ? max_side_overhang : 99999
    );

    if (
        area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT &&
        (area_design_specs.SHAPE.SheetDirection === "Left" || area_design_specs.SHAPE.SheetDirection === "Right")
    ) {
        let holder = maxFrontBackEndSpan;
        maxFrontBackEndSpan = max_left_overhang;
        max_left_overhang = holder;
        max_right_overhang = holder;

        holder = min_side_overhang;
        min_side_overhang = min_front_overhang;
        min_front_overhang = holder;
    }

    let SpanNotes = "";

    let reduction_factor = 10;
    if (RoofSheetParameters.RoofSheetData["SkylightSpanReductionFactor"]) {
        reduction_factor = RoofSheetParameters.RoofSheetData["SkylightSpanReductionFactor"];
    }

    if (
        area_design_specs.META.HasInsulatedPanel &&
        area_design_specs.SKYLIGHTS &&
        area_design_specs.SKYLIGHTS.length > 0
    ) {
        let span_reduction_note = "*spans reduced by " + reduction_factor + "% with skylights";
        if (reduction_factor === 25) {
            span_reduction_note = "*spans reduced by " + reduction_factor + "% with skylights when 1 sheet apart";
        }
        SpanNotes = (
            <>
                *cannot be multispan with skylights
                <br />
                {span_reduction_note}
            </>
        );
    }

    return (
        <div className={classes.root}>
            <BSL_Common.SectionHeader style={{ paddingTop: "0px" }}>Roof Sheeting</BSL_Common.SectionHeader>
            <BSL_Common.SectionContainer>
                <BSL_Select
                    style={{ flex: 1 }}
                    value={RoofSheetParameters.RoofGroupType}
                    tight={true}
                    items={sheet_menu_items}
                    onChange={updateRoofData("RoofGroupType")}
                    disabled={carportMode}
                />
                <BSL_Common.SectionRow>
                    <SegmentedButtonGroup
                        label="Material"
                        tight
                        value={RoofSheetParameters.RoofSubType}
                        items={sheet_menu_sub_items}
                        onChange={updateRoofData("RoofSubType")}
                        style={{
                            marginTop: "-12px",
                        }}
                    />
                    {!carportMode && (
                        <>
                            <BSL_Common.SectionColumn>
                                <SegmentedButtonGroup
                                    label="Span Allowance"
                                    tight
                                    value={RoofSheetParameters.RoofSpan}
                                    items={span_items}
                                    onChange={updateRoofData("RoofSpan")}
                                    style={{
                                        marginTop: "-12px",
                                    }}
                                />

                                <>
                                    <BSL_Common.SectionRow
                                        style={{
                                            fontSize: "9px",
                                        }}
                                    >
                                        <BSL_Common.SectionColumn
                                            style={{
                                                font: "inherit",
                                            }}
                                        >
                                            <b>END SPAN</b>

                                            {generateSpanText(RoofSheetParameters?.RoofSheetData?.max_end_span)}
                                        </BSL_Common.SectionColumn>
                                        <BSL_Common.SectionColumn
                                            style={{
                                                font: "inherit",
                                            }}
                                        >
                                            <b>INTERNAL</b>
                                            {generateSpanText(RoofSheetParameters?.RoofSheetData?.max_internal_span)}
                                        </BSL_Common.SectionColumn>
                                        <BSL_Common.SectionColumn
                                            style={{
                                                font: "inherit",
                                            }}
                                        >
                                            <b>O/H</b>
                                            {generateSpanText(RoofSheetParameters?.RoofSheetData?.max_overhang)}
                                        </BSL_Common.SectionColumn>
                                    </BSL_Common.SectionRow>
                                    {RoofSheetParameters?.RoofSheetData?.PressureTableMaxSpanSingle > 0 && (
                                        <BSL_Common.SectionRow
                                            style={{
                                                fontSize: "9px",
                                            }}
                                        >
                                            <BSL_Common.SectionColumn
                                                style={{
                                                    font: "inherit",
                                                }}
                                            >
                                                <b>PRESSURE</b>
                                                Single Span
                                                <br />
                                                Double Span
                                            </BSL_Common.SectionColumn>
                                            <BSL_Common.SectionColumn
                                                style={{
                                                    font: "inherit",
                                                }}
                                            >
                                                <b>TABLES</b>
                                                {generateSpanText(
                                                    RoofSheetParameters?.RoofSheetData?.PressureTableMaxSpanSingle
                                                )}
                                                {generateSpanText(
                                                    RoofSheetParameters?.RoofSheetData?.PressureTableMaxSpanDouble
                                                )}
                                            </BSL_Common.SectionColumn>
                                            <BSL_Common.SectionColumn
                                                style={{
                                                    font: "inherit",
                                                }}
                                            >
                                                <b></b>
                                            </BSL_Common.SectionColumn>
                                        </BSL_Common.SectionRow>
                                    )}
                                    {SpanNotes && (
                                        <BSL_Common.SectionRow
                                            style={{
                                                fontSize: "9px",
                                                textAlign: "start",
                                                whiteSpace: "pre-wrap",
                                                color: "#813737",
                                            }}
                                        >
                                            {SpanNotes}
                                        </BSL_Common.SectionRow>
                                    )}
                                </>
                            </BSL_Common.SectionColumn>
                        </>
                    )}
                </BSL_Common.SectionRow>

                <BSL_Common.SectionRow>
                    <BSL_ColourSelector
                        label="Colour"
                        tight
                        colourList={roofSheetColourArray.length === 1 ? roofSheetColourArray : ["TBA", colourList]}
                        value={
                            RoofSheetParameters?.RoofColourSelectionMade ? RoofSheetParameters?.RoofSheetColour : "TBA"
                        }
                        onChange={updateRoofData("RoofSheetColour")}
                        style={{
                            marginTop: "-12px",
                        }}
                    />
                </BSL_Common.SectionRow>

                {!carportMode && (
                    <>
                        <BSL_Common.SectionRow>
                            {area_design_specs.SHAPE.DesignType !== CONFIG.DESIGN_TYPES.GABLE_PORTAL && (
                                <SegmentedButtonGroup
                                    label="Sheet Laying"
                                    tight
                                    value={RoofSheetParameters.SheetLaying}
                                    items={[
                                        {
                                            Key: 0,
                                            Display: "Auto",
                                        },
                                        {
                                            Key: 2,
                                            Display: "Left",
                                        },
                                        {
                                            Key: 3,
                                            Display: "Right",
                                        },
                                        {
                                            Key: 1,
                                            Display: "Offset",
                                        },
                                    ]}
                                    onChange={updateRoofData("SheetLaying")}
                                    style={{
                                        marginTop: "-12px",
                                        flex: 7,
                                    }}
                                />
                            )}

                            {RoofSheetParameters.SheetLaying === 1 && (
                                <>
                                    <SpecSetRoofLayingOffset areaIndex={areaIndex} />
                                    <BSL_TextInput
                                        label="Offset"
                                        value={RoofSheetParameters?.SheetLayingOffset}
                                        tight
                                        min={0}
                                        max={ShapeParameters.Length}
                                        endAdornment="mm"
                                        onBlur={updateRoofData("SheetLayingOffset")}
                                        style={{
                                            marginTop: "-12px",
                                            flex: 3,
                                        }}
                                    />
                                </>
                            )}
                        </BSL_Common.SectionRow>

                        <BSL_Common.SectionHeader>Sheet Overhangs</BSL_Common.SectionHeader>
                        <BSL_Common.SectionContainer>
                            <BSL_Common.SectionRow>
                                <BSL_TextInput
                                    label="Front"
                                    value={ShapeParameters?.OH_Front_Sheet}
                                    tight
                                    min={min_front_overhang ? min_front_overhang : 0}
                                    max={maxFrontBackEndSpan}
                                    endAdornment="mm"
                                    onBlur={updateShapeData("OH_Front_Sheet")}
                                    disabled={maxFrontBackEndSpan === 0 || maxFrontBackEndSpan == min_front_overhang}
                                    disabledTooltip={
                                        maxFrontBackEndSpan === 0 || maxFrontBackEndSpan == min_front_overhang
                                            ? "Front and Back overhangs not allowed for " + designType
                                            : ""
                                    }
                                />
                                <BSL_TextInput
                                    label="Back"
                                    value={ShapeParameters?.OH_Back_Sheet}
                                    tight
                                    min={min_front_overhang ? min_front_overhang : 0}
                                    max={maxFrontBackEndSpan}
                                    endAdornment="mm"
                                    onBlur={updateShapeData("OH_Back_Sheet")}
                                    disabled={maxFrontBackEndSpan === 0}
                                    disabledTooltip={
                                        maxFrontBackEndSpan === 0
                                            ? "Front and Back overhangs not allowed for " + designType
                                            : ""
                                    }
                                />
                                <BSL_TextInput
                                    label="Left"
                                    value={ShapeParameters?.OH_Left_Sheet}
                                    tight
                                    min={min_side_overhang ? min_side_overhang : 0}
                                    max={max_left_overhang}
                                    endAdornment="mm"
                                    onBlur={updateShapeData("OH_Left_Sheet")}
                                    disabled={max_left_overhang === 0 || max_left_overhang === min_side_overhang}
                                    disabledTooltip={
                                        design_option?.overhang_left_range?.max === 0
                                            ? "Side overhangs not allowed for " + designType
                                            : max_side_overhang === 0 || max_left_overhang === min_side_overhang
                                            ? "Side overhangs not allowed for this roof sheet type"
                                            : ""
                                    }
                                />
                                <BSL_TextInput
                                    label="Right"
                                    value={ShapeParameters?.OH_Right_Sheet}
                                    tight
                                    min={min_side_overhang ? min_side_overhang : 0}
                                    max={max_right_overhang}
                                    endAdornment="mm"
                                    onBlur={updateShapeData("OH_Right_Sheet")}
                                    disabled={max_right_overhang === 0 || max_right_overhang === min_side_overhang}
                                    disabledTooltip={
                                        design_option?.overhang_right_range?.max === 0
                                            ? "Side overhangs not allowed for " + designType
                                            : max_side_overhang === 0 || max_right_overhang === min_side_overhang
                                            ? "Side overhangs not allowed for this roof sheet type"
                                            : ""
                                    }
                                />
                            </BSL_Common.SectionRow>
                        </BSL_Common.SectionContainer>
                    </>
                )}
            </BSL_Common.SectionContainer>

            {!carportMode && (
                <>
                    <BSL_Common.SectionHeader>Skylight</BSL_Common.SectionHeader>
                    <BSL_Common.SectionContainer>
                        <BSL_Common.SectionRow>
                            <BSL_Select
                                disabled={!skylight_list}
                                value={!skylight_list ? "No Skylights" : RoofSheetParameters.SkylightSubType}
                                tight={true}
                                items={!skylight_list ? ["No Skylights"] : skylight_list}
                                onChange={updateRoofData("SkylightSubType")}
                                style={{ flex: 1 }}
                            />
                            <BSL_ColourSelector
                                disabled={!skylight_list}
                                tight
                                colourList={skylightColourList}
                                value={RoofSheetParameters?.SkylightColour}
                                onChange={updateRoofData("SkylightColour")}
                            />
                        </BSL_Common.SectionRow>
                        <BSL_Button
                            onClick={wipeSkylights(areaIndex)}
                            style={{
                                marginLeft: "8px",
                                alignSelf: "center",
                            }}
                            disabled={!skylightsflag}
                        >
                            Remove Skylights (Area)
                        </BSL_Button>
                    </BSL_Common.SectionContainer>
                </>
            )}

            <BSL_Common.SectionHeader>Flashings</BSL_Common.SectionHeader>
            <BSL_Common.SectionContainer>
                <BSL_Common.SectionRow>
                    <BSL_ColourSelector
                        label="Barge/Flashing Colour"
                        tight
                        colourMatch={colourMatch}
                        colourList={["Match Roofsheet", "TBA", ...valid_barge_colours]}
                        value={RoofSheetParameters?.FlashingColourMatchString}
                        onChange={updateRoofData("FlashingColourMatchString")}
                    />
                    {!carportMode && (
                        <BSL_ColourSelector
                            label="Ridge Colour"
                            tight
                            colourMatch={ridgeColourMatch}
                            colourList={["Match Barge", "Match Roofsheet", "TBA", ...valid_ridge_colours]}
                            value={RoofSheetParameters?.RidgeColourMatchString}
                            onChange={updateRoofData("RidgeColourMatchString")}
                            allowInvalid={true}
                        />
                    )}
                    {design_option?.allow_roll_top_ridge && RoofSheetParameters?.RoofGroupType === "CUSTOM ORB" && (
                        <SegmentedButtonGroup
                            label="Ridge Flashing Type"
                            tight
                            value={RoofSheetParameters.RollTopRidge}
                            items={[
                                {
                                    Key: false,
                                    Display: "Contemporary Ridge",
                                },
                                {
                                    Key: true,
                                    Display: "Roll Top Ridge",
                                },
                            ]}
                            onChange={updateRoofData("RollTopRidge")}
                            style={{
                                flex: 7,
                            }}
                        />
                    )}
                </BSL_Common.SectionRow>
            </BSL_Common.SectionContainer>
        </div>
    );
}
